import type { FC } from 'react';

import { Trans } from 'react-i18next';

import classNames from 'classnames';

interface ICustomWatermarkProps {
  className?: string;
}

export const CustomWatermark: FC<ICustomWatermarkProps> = ({ className }) => {
  return (
    <div
      className={classNames(
        'absolute bottom-5 max-w-[min(240px,_100%)] w-full left-[50%] text-base leading-[20px] py-2 px-3 rounded-lg -translate-x-1/2 size-fit bg-black/40 opacity-80 text-white text-center max-sm:text-base max-sm:bottom-2 max-sm:leading-4 max-sm:py-1.5 max-sm:px-2',
        className
      )}
    >
      PDF Guru <br />
      <Trans i18nKey='custom_watermark.text' />
    </div>
  );
};
